module.exports = __webpack_public_path__ + "ae8d1003388a5a689d8badeb70b6da01.glb";